import React from 'react';
import { Form, Input } from 'antd';
const { Group } = Input;

// todo onChange={handleFilterPrice}
const RouteLength = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Длина маршрута, км:" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('RouteLengthFrom')(
          <Input style={{ width: '50%' }} placeholder="от" />
        )}
        {getFieldDecorator('RouteLengthTo')(
          <Input style={{ width: '50%' }} placeholder="до" />
        )}
      </Group>
    </Form.Item>
  );
};

export default RouteLength;
